<script>
export default {
  props: {},

  data: () => ({
    //
  }),
};
</script>

<template>
  <div class="swiper-slide">
    <slot />
  </div>
</template>
